import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../selectors/users';
import { getModuleData, getModuleMeta } from '../../../selectors/modules';
import { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { Props as FeaturedDeviationProps } from './FeaturedDeviation';

type Props = FeaturedDeviationProps & WidgetBoxProps;
type StateProps = Pick<
  Props,
  'isNewlyAddedModule' | 'deviation' | 'profileOwnerUser' | 'isOwner'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const moduleData = getModuleData(state, ownProps.moduleId);
  const deviation = getDeviationById(state, moduleData.deviation);
  return {
    ...moduleData,
    isNewlyAddedModule: Boolean(
      getModuleMeta(state, ownProps.moduleId).isNewlyAdded
    ),
    deviation,
    profileOwnerUser: getProfileOwnerUser(state),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

export default connect(mapStateToProps);
